<div class="list-container">
  @for (user of page()?.content; track user.tag + user.origin; let i = $index) {
    <div class="list-number">{{ i + page()!.page.number * page()!.page.size + 1 }}</div>
    <app-user [user]="user" [profile]="getProfile(user)" />
  }
  @for (profile of scim()?.content; track profile.tag; let i = $index) {
    @if (!hasUser(profile.tag)) {
      <div class="list-number">{{ i + scim()!.page.number * scim()!.page.size + (page() ? page()!.content.length + page()!.page.number * page()!.page.size : 0) }}</div>
      <app-user [profile]="profile" />
    }
  }
</div>
@if (!page()) {
  <app-loading />
} @else if (page()!.content.length) {
  <app-page-controls [page]="page()" />
} @else {
  <p class="no-results" i18n>
    No results found
  </p>
}
